import { t } from "@lingui/macro";
import { UiBox } from "@smp/ui";
import { MapRecord } from "@smp/utils";
import { IconPalette } from "@tabler/icons-react";
import { FC, useMemo } from "react";

import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";
import {
  FilterColorButton,
  FilterGroupWrapper,
} from "@/components/features/polotno_templates/screens/filters/components/_shared";
import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";

export const ColorTagSelector: FC<{
  group: MapRecord<
    ReturnType<typeof useQueryPolotnoTagsAll>["data"]["grouped"]
  >;
}> = ({ group }) => {
  const getTranslation = useSmpAgTranslation();

  const {
    actions: { updateSelectedTags },
    state: { selectedTags },
  } = useContextPolotnoTemplates();

  const isAllActive = useMemo(
    () =>
      Boolean(group && !selectedTags.some((tag) => tag.startsWith(group.slug))),
    [group, selectedTags],
  );

  if (!group?.children.length) {
    return null;
  }

  return (
    <FilterGroupWrapper
      icon={<IconPalette />}
      title={getTranslation(group.name)}
    >
      <UiBox display="flex" flexWrap="wrap" gap={1}>
        <FilterColorButton
          isActive={isAllActive}
          title={t`Show all`}
          value={"all"}
          onChange={() => updateSelectedTags(group.slug, undefined)}
        />
        {group.children.map((tag) => {
          const hex = tag.slug.split("_").at(-1);
          const name = tag.translations.en?.toLowerCase();

          if (!hex || !name) {
            return null;
          }

          return (
            <FilterColorButton
              key={tag.slug}
              isActive={selectedTags.includes(tag.slug)}
              color={`#${hex}`}
              title={getTranslation(tag.translations)}
              value={name}
              onChange={() => updateSelectedTags(group.slug, tag.slug)}
            />
          );
        })}
      </UiBox>
    </FilterGroupWrapper>
  );
};
